/**
 * @deprecated Import from '@/components/shared/engine-indicator' instead.
 * This re-export exists only for backward compatibility while consumers are migrated.
 */
export { EngineIndicator, EnginesRow } from '@/components/shared/engine-indicator'
